import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  getDistance,
  middle,
  radiusZoomLevel,
} from "../../utils/staticMethods";
import DrawingManager from "./DrawingManager";
import { useImageOverlay } from "../../utils/useImageOverlay";
import "../../utils/imageOverlay.css";

const FloorplanOverlay = ({
  mode = "view",
  img,
  curFloor,
  opacity,
  rotate,
  selectedGeometry,
  setSelectedGeometry,
  setPosition,
  setPosition1,
}) => {
  const map = useMap();
  const mapLibCore = useMapsLibrary("core");
  const mapLibMaps = useMapsLibrary("maps");

  const [initialNW, setInitialNW] = useState(null);
  const [initialSE, setInitialSE] = useState(null);
  const [initialRotate, setInitialRotate] = useState(null);

  const handleBoundsChanged = useCallback(
    (nw, se) => {
      if (!setPosition || !setPosition1) return;
      // console.log("Updated bounds", nw.toString(), se.toString());
      // save to API or localStorage here
      setPosition(nw);
      setPosition1(se);
    },
    // []
    [setPosition, setPosition1]
  );

  const handleImageLoaded = useCallback(() => {
    // console.log("%chandle image loaded", "background: #fdb2ed");

    let zoom = 5;
    let d = getDistance(initialNW, initialSE);
    let keys = Object.keys(radiusZoomLevel).reverse();
    let value = 100000000000;
    let index = 0;
    for (let i = 0; i < keys.length; i++) {
      let v = Math.abs(radiusZoomLevel[keys[i]] - d);
      if (v < value) {
        value = v;
        index = keys[i];
      }
    }
    zoom = Number(index - 1);

    let center = middle(initialNW, initialSE);
    let heading = initialRotate || 0;

    // window.requestAnimationFrame(function () {
    //   map.moveCamera({ center, zoom, heading: 360 - heading });
    // });

    window.requestAnimationFrame(function () {
      map.moveCamera({ center });
      window.requestAnimationFrame(function () {
        map.moveCamera({ zoom });
        window.requestAnimationFrame(function () {
          map.moveCamera({ heading: 360 - heading });
        });
      });
    });
  }, [map, initialNW, initialSE, initialRotate, getDistance]);

  const overlayRef = useImageOverlay({
    mode,
    map,
    imageSrc: img,
    initialNW,
    initialSE,
    initialRotate,
    onBoundsChanged: handleBoundsChanged,
    onImageLoaded: handleImageLoaded,
  });

  useEffect(() => {
    if (!map || !mapLibCore || !curFloor) return;

    let nw = new mapLibCore.LatLng(
      curFloor?.northWestLatitude,
      curFloor?.northWestLongitude
    );
    let se = new mapLibCore.LatLng(
      curFloor?.southEastLatitude,
      curFloor?.southEastLongitude
    );

    setInitialNW(nw);
    setInitialSE(se);
    setInitialRotate(curFloor?.rotation || 0);
    let center = middle(nw, se);

    map.moveCamera({
      center: center, // new mapLibCore.LatLng(0, 0),
      zoom: 22,
      heading: 0,
    });

    return () => {
      map.moveCamera({
        center: new mapLibCore.LatLng(0, 0),
        zoom: 3,
        heading: 0,
      });
    };
  }, [map, mapLibCore, curFloor]);

  // const handleMapIdle = useCallback(() => {
  //   console.log("map idle");
  //   setMapReady(true);
  // }, []);

  // useEffect(() => {
  //   // map.setMapTypeId("satellite");
  // }, [map]);

  // useEffect(() => {
  //   if (!map) return;
  //   map.setOptions({
  //     gestureHandling: "none",
  //     // draggable: false,
  //     // scrollwheel: false,
  //     // disableDoubleClickZoom: true,
  //   });
  // }, [map]);

  // useEffect(() => {
  //   console.log("set rotate", { map, rotate });
  //   if (!map || !curFloor || !rotate) return;
  //   console.log("setting rotate", rotate);
  //   map.setHeading(360 - rotate);
  // }, [map, curFloor, rotate]);

  // useEffect(() => {
  //   if (!map || !mapLibCore || !handleMapIdle || !setIdleListener) return;

  //   // setIdleListener(map.addListener("idle", handleMapIdle));

  //   return () => {
  //     if (idleListener) {
  //       mapLibCore.event.removeListener(idleListener);
  //       setIdleListener(null);
  //     }
  //   };
  // }, [map, mapLibCore, handleMapIdle, setIdleListener]);

  useEffect(() => {
    if (
      !map ||
      !initialNW ||
      !initialSE ||
      !initialRotate ||
      !overlayRef.current
    )
      return;

    // console.log("Overlay loaded 🚐🚐🚐");

    return () => {
      // map.moveCamera({
      //   // center: map.getCenter(),
      //   zoom: 4,
      //   heading: 0,
      // });
    };
  }, [map, initialNW, initialSE, initialRotate, overlayRef.current]);

  // useEffect(() => {
  //   setImageUrl(img);
  //   console.log("img changed", { img });
  // }, [img]);

  // useEffect(() => {
  //   console.log("initialRotate changed effect", { rotate, overlayRef });
  //   if (!rotate) return;

  //   overlayRef?.current?.setRotation?.(rotate);
  // }, [rotate, overlayRef.current]);

  // useEffect(() => {
  //   if (!map || !rotate) return;
  //   console.log("ror🤪", { map, rotate });
  //   if (overlayRef.current) {
  //     map.setHeading(360 - rotate);
  //   }
  // }, [rotate, map, overlayRef.current]);

  useEffect(() => {
    if (!map || !rotate || !overlayRef.current) return;
    // console.log("ror🤪 %s", overlayRef.current.imageLoaded, { map, rotate });
    // map.setHeading(360 - rotate);
    if (overlayRef.current.imageLoaded) {
      map.moveCamera({ heading: 360 - rotate });
    }
  }, [map, rotate, overlayRef.current]);

  useEffect(() => {
    overlayRef.current?.setOpacity(opacity);
  }, [opacity]);

  // useEffect(() => {
  //   if (
  //     !overlayRef.current ||
  //     !map ||
  //     !mapLibCore ||
  //     !rotate ||
  //     !initialNW ||
  //     !initialSE
  //   )
  //     return;
  //   map.setHeading(360 - rotate);

  //   let center = new mapLibCore.LatLng(
  //     (initialNW.lat() + initialSE.lat()) / 2,
  //     (initialNW.lng() + initialSE.lng()) / 2
  //   );

  //   map.panTo(center);
  // }, [overlayRef.current, map, mapLibCore, rotate, initialNW, initialSE]);

  // useEffect(() => {
  //   setInitialNW(
  //     new mapLibCore.LatLng(
  //       curFloor?.northWestLatitude,
  //       curFloor?.northWestLongitude
  //     )
  //   );
  // }, [curFloor, mapLibCore]);

  // useImageOverlay({
  //   map,
  //   initialNW: new mapLibCore.LatLng(
  //     curFloor.northWestLatitude,
  //     curFloor.northWestLongitude
  //   ),
  //   initialSE: new mapLibCore.LatLng(
  //     curFloor.southEastLatitude,
  //     curFloor.southEastLongitude
  //   ),
  //   imageSrc: imageUrl,
  //   minWidthPx: 40,
  //   initialOpacity: opacity || 1,
  // });

  // const initialNW = {
  //   lat: Number(curFloor?.northWestLatitude ?? "0"),
  //   lng: Number(curFloor?.northWestLongitude ?? "0"),
  // };
  // const initialSE = {
  //   lat: Number(curFloor?.southEastLatitude ?? "0"),
  //   lng: Number(curFloor?.southEastLongitude ?? "0"),
  // };

  // You store NW + SE in your DB, so keep using that:
  // const [nw, setNW] = useState();
  // const [se, setSE] = useState();
  // const [center, setCenter] = useState();

  // const [bounds, setBounds] = useState();

  // const center = {
  //   lat: (nw.lat + se.lat) / 2,
  //   lng: (nw.lng + se.lng) / 2,
  // };

  // const latLngToObj = (p) => ({ lat: p.lat(), lng: p.lng() });

  // const [overlay, setOverlay] = useState();
  // const overlayRef = useRef();

  // useImperativeHandle(
  //   ref,
  //   () => {
  //     return {
  //       changeOverlayPosition: (positionName, coordinateName, value) => {
  //         //   let overlay = overlayRef.current;
  //         //   if (overlay && overlay.getProjection()) {
  //         //     //debugger;
  //         //     if (overlay && mapLibCore && positionName === "position") {
  //         //       if (coordinateName === "lat") {
  //         //         overlay[positionName] = new mapLibCore.LatLng(
  //         //           Number(value),
  //         //           overlay[positionName].lng()
  //         //         );
  //         //       } else if (coordinateName === "lng") {
  //         //         overlay[positionName] = new mapLibCore.LatLng(
  //         //           overlay[positionName].lat(),
  //         //           Number(value)
  //         //         );
  //         //       }
  //         //       let pos = overlay
  //         //         .getProjection()
  //         //         .fromLatLngToDivPixel(overlay.position);
  //         //       let x = pos.x + overlay.div.clientWidth;
  //         //       let y = pos.y + overlay.div.clientHeight;
  //         //       let bottom = overlay
  //         //         .getProjection()
  //         //         .fromDivPixelToLatLng({ x, y });
  //         //       overlay.position1 = bottom;
  //         //       overlay.draw();
  //         //     } else if (
  //         //       overlay &&
  //         //       mapLibCore &&
  //         //       positionName === "position1"
  //         //     ) {
  //         //       if (coordinateName === "lat") {
  //         //         overlay[positionName] = new mapLibCore.LatLng(
  //         //           Number(value),
  //         //           overlay[positionName].lng()
  //         //         );
  //         //       } else if (coordinateName === "lng") {
  //         //         overlay[positionName] = new mapLibCore.LatLng(
  //         //           overlay[positionName].lat(),
  //         //           Number(value)
  //         //         );
  //         //       }
  //         //       let pos = overlay
  //         //         .getProjection()
  //         //         .fromLatLngToDivPixel(overlay.position1);
  //         //       let x = pos.x - overlay.div.clientWidth;
  //         //       let y = pos.y - overlay.div.clientHeight;
  //         //       let top = overlay
  //         //         .getProjection()
  //         //         .fromDivPixelToLatLng({ x, y });
  //         //       overlay.position = top;
  //         //       overlay.draw();
  //         //     }
  //         //   }
  //         console.log("changeOverlayPosition - not implemented");
  //       },
  //     };
  //   },
  //   []
  // );

  useEffect(() => {
    if (!curFloor || !mapLibMaps) return;

    // const initialNW = {
    //   lat: Number(curFloor?.northWestLatitude ?? "0"),
    //   lng: Number(curFloor?.northWestLongitude ?? "0"),
    // };
    // const initialSE = {
    //   lat: Number(curFloor?.southEastLatitude ?? "0"),
    //   lng: Number(curFloor?.southEastLongitude ?? "0"),
    // };

    // // You store NW + SE in your DB, so keep using that:
    // setNW(initialNW);
    // setSE(initialSE);

    // // // Derive SW + NE for math + overlays
    // const derived = {
    //   sw: { lat: initialSE.lat, lng: initialNW.lng },
    //   ne: { lat: initialNW.lat, lng: initialSE.lng },
    // };

    // setBounds({
    //   south: derived.sw.lat,
    //   west: derived.sw.lng,
    //   north: derived.ne.lat,
    //   east: derived.ne.lng,
    // });

    const initPolygon = () => {
      if (!curFloor.polygon || curFloor.polygon.length === 0) return;
      let firstItem = curFloor.polygon[0].split(",");
      let minLat = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
        maxLat = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
        minLng = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
        maxLng = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) };
      let arr = curFloor.polygon.map((item) => {
        let me = item.split(",");
        let lng = Number(me[0]);
        let lat = Number(me[1]);
        if (lat > maxLat.lat) maxLat = { lat, lng };
        if (lat < minLat.lat) minLat = { lat, lng };
        if (lng > maxLng.lng) maxLng = { lat, lng };
        if (lng < minLng.lng) minLng = { lat, lng };
        return { lng, lat };
      });
      let point1 = new mapLibCore.LatLng(minLat);
      let point2 = new mapLibCore.LatLng(maxLat);
      let point3 = new mapLibCore.LatLng(minLng);
      let point4 = new mapLibCore.LatLng(maxLng);
      let d1 = getDistance(point1, point2);
      let d2 = getDistance(point3, point4);
      let d = d1 > d2 ? d1 : d2;

      setSelectedGeometry?.(
        new mapLibMaps.Polygon({
          paths: arr,
          strokeColor: "#000000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#242424",
          fillOpacity: 0.3,
          geodesic: true,
          type: "polygon",
          // center: new mapLibCore.LatLng(
          //   Number(zone.latitude),
          //   Number(zone.longitude)
          // ),
        })
      );

      //selectShape.setMap(mapInstance);

      // listener1 = selectShape.addListener("dragend", (e) => {
      //   addCenterPointForPolygon();
      // });
      // mapInstance.panTo({
      //   lat: Number(zone.latitude),
      //   lng: Number(zone.longitude),
      // });
      // let keys = Object.keys(radiusZoomLevel).reverse();
      // let value = 1000000;
      // let index = 0;
      // for (let i = 0; i < keys.length; i++) {
      //   let v = Math.abs(radiusZoomLevel[keys[i]] - d);
      //   if (v < value) {
      //     value = v;
      //     index = keys[i];
      //   }
      // }
      // addCenterPointForPolygon(Number(zone.latitude), Number(zone.longitude));
      // mapInstance.setZoom(Number(index));
    };
    initPolygon();
  }, [curFloor, mapLibMaps]);

  // useEffect(() => {
  //   if (!map || !mapLibMaps) return;

  //   // const b = new mapLibCore.LatLngBounds(
  //   //   new mapLibCore.LatLng(bounds.se.lat, bounds.se.lng),
  //   //   new mapLibCore.LatLng(bounds.nw.lat, bounds.nw.lng)
  //   // );

  //   var overlayView = new mapLibMaps.OverlayView(imageUrl, bounds, {
  //     clickable: false,
  //     opacity: 0.75,
  //   });

  //   overlayView.draw = () => {
  //     if (map.getHeading() !== 360 - rotate && map.getHeading() !== rotate) {
  //       map.setHeading(360 - rotate);
  //     }
  //     const overlayProjection = overlayView.getProjection();
  //     if (overlayView.div && overlayProjection) {
  //       let pos1 = overlayProjection.fromLatLngToDivPixel(overlayView.position);
  //       overlayView.div.style.left = pos1.x + "px";
  //       overlayView.div.style.top = pos1.y + "px";
  //       if (
  //         overlayView.position1 &&
  //         overlayView.div.style.cursor !== "move" &&
  //         overlayView.rotating === false
  //       ) {
  //         const se = overlayProjection.fromLatLngToDivPixel(
  //           overlayView.position1
  //         );
  //         overlayView.div.style.width = se.x - pos1.x + "px";
  //         overlayView.div.style.height = "fit-content";
  //       }
  //       overlayView.rotating = false;
  //     }
  //     setPosition(overlayView.position);
  //     setPosition1(overlayView.position1);
  //   };

  //   overlayView.setMap(map);
  //   // setOverlay(go);

  //   return () => overlayView.setMap(null);
  // }, [map, mapLibMaps]);

  // Keep the floorplan square when resizing

  // useEffect(() => {
  //   if (
  //     !map ||
  //     !mapLibCore ||
  //     !mapLibMaps ||
  //     !window.google ||
  //     !window.google.maps ||
  //     !overlay ||
  //     !imageUrl ||
  //     !curFloor
  //   ) {
  //     return;
  //   }

  //   overlay.initFromBounds(
  //     new mapLibCore.LatLng(
  //       curFloor.northWestLatitude,
  //       curFloor.northWestLongitude
  //     ),
  //     new mapLibCore.LatLng(
  //       curFloor.southEastLatitude,
  //       curFloor.southEastLongitude
  //     )
  //   );

  //   // overlayRef.current = useImageOverlay({
  //   //   map,
  //   //   initialNW: new mapLibCore.LatLng(
  //   //     curFloor.northWestLatitude,
  //   //     curFloor.northWestLongitude
  //   //   ),
  //   //   initialSE: new mapLibCore.LatLng(
  //   //     curFloor.southEastLatitude,
  //   //     curFloor.southEastLongitude
  //   //   ),
  //   //   imageSrc: imageUrl,
  //   //   minWidthPx: 40,
  //   //   initialOpacity: opacity || 1,
  //   // });

  //   // let cancelled = false;
  //   // let overlay = null;

  //   // (async () => {
  //   //   console.log("creating overlay");

  //   //   // Load dynamically
  //   //   const { FloorplanImageOverlay } = await import(
  //   //     "../../utils/FloorplanImageOverlay"
  //   //   );

  //   //   if (cancelled) return;

  //   //   overlay = new FloorplanImageOverlay(
  //   //     mode,
  //   //     curFloor,
  //   //     imageUrl,
  //   //     setPosition,
  //   //     setPosition1
  //   //   );

  //   //   overlay.setMap(map);
  //   //   overlayRef.current = overlay;

  //   //   // Optional rotation
  //   //   // overlayRef.current.setRotation(curFloor.rotation);
  //   // })();

  //   // return () => {
  //   //   console.log("cleanup overlay");
  //   //   cancelled = true;

  //   //   if (overlay) {
  //   //     overlay.setMap(null); // detach
  //   //   }

  //   //   overlayRef.current = null;
  //   // };
  // }, [map, mapLibCore, mapLibMaps, overlay, imageUrl, curFloor]);

  // useEffect(() => {
  //   if (!map || !rotate) return;

  //   overlayRef.current.rotation = rotate;
  // }, [map, rotate]);

  // useEffect(() => {
  //   if (!map || !overlayRef.current || !rotate) return;
  //   console.log("ror🤪", { map, rotate });
  //   overlayRef.current.setRotation(rotate);

  //   // if (map.getHeading() !== 360 - rotate && map.getHeading() !== rotate) {
  //   //   map.setHeading(360 - rotate);
  //   //   if (overlayRef.current) {
  //   //     overlayRef.current.rotating = true;
  //   //     overlayRef.current.draw();
  //   //   }
  //   // }
  //   // console.log("ror🤪");
  //   // if (map) {
  //   //   // if (map.getHeading() !== 360 - rotate && map.getHeading() !== rotate) {
  //   //   //   map.setHeading(360 - rotate);
  //   //   //   // this.rotating = true;
  //   //   // }
  //   //   if (rotate) {
  //   //     map.setHeading(rotate);
  //   //   } else {
  //   //     map.setHeading(0);
  //   //   }
  //   //   console.log("fp rot", { rotate });
  //   // }
  // }, [map, overlayRef.current, rotate]);

  // useEffect(() => {
  //   if (!map || !overlay || !opacity) return;
  //   overlay.setOpacity(opacity);
  // }, [map, overlay, opacity]);

  // useEffect(() => {
  //   if (!map || !overlayRef.current || !imageUrl) return;
  //   overlayRef.current.setImage(imageUrl);
  // }, [map, overlayRef.current, imageUrl]);

  // useEffect(() => {
  //   if (!map || !overlayRef.current || !curFloor) return;
  //   overlayRef.current.initFromBounds(
  //     new mapLibCore.LatLng(
  //       curFloor.northWestLatitude,
  //       curFloor.northWestLongitude
  //     ),
  //     new mapLibCore.LatLng(
  //       curFloor.southEastLatitude,
  //       curFloor.southEastLongitude
  //     )
  //   );
  // }, [map, overlayRef.current, curFloor]);

  // useEffect(() => {
  //   if (!map || !overlayRef.current || !opacity) return;

  //   let overlayDiv = overlayRef.current.get("div");
  //   if (overlayDiv) {
  //     overlayDiv.style.opacity = opacity / 100;
  //   }
  // }, [map, overlayRef.current, opacity]);

  // const updateCorner = useCallback(
  //   (corner, pos) => {
  //     if (!pos) return;
  //     const newPos = latLngToObj(pos);

  //     let newNW = { ...nw };
  //     let newSE = { ...se };

  //     if (corner === "nw") {
  //       newNW = newPos;
  //     }
  //     if (corner === "se") {
  //       newSE = newPos;
  //     }

  //     // Normalize coordinates (prevent flipped coords)
  //     const north = Math.max(newNW.lat, newSE.lat);
  //     const south = Math.min(newNW.lat, newSE.lat);
  //     const west = Math.min(newNW.lng, newSE.lng);
  //     const east = Math.max(newNW.lng, newSE.lng);

  //     // Compute width/height
  //     const height = north - south;
  //     const width = east - west;

  //     // Force square aspect ratio
  //     const size = Math.max(width, height);

  //     // Recalculate NW + SE as a square
  //     setNW({ lat: south + size, lng: west }); // NW = top-left
  //     setSE({ lat: south, lng: west + size }); // SE = bottom-right
  //   },
  //   [nw, se]
  // );

  // // Move the entire image via center drag
  // const moveWhole = (newCenterPos) => {
  //   const newC = latLngToObj(newCenterPos);
  //   const offsetLat = newC.lat - 0; //center.lat;
  //   const offsetLng = newC.lng - 0; //center.lng;

  //   setNW({
  //     lat: nw.lat + offsetLat,
  //     lng: nw.lng + offsetLng,
  //   });
  //   setSE({
  //     lat: se.lat + offsetLat,
  //     lng: se.lng + offsetLng,
  //   });
  // };

  return (
    <React.Fragment>
      {mode === "edit" && (
        <DrawingManager
          selectedGeometry={selectedGeometry}
          onSelectedGeometryChanged={(geometry) => {
            setSelectedGeometry?.(geometry);
          }}
        ></DrawingManager>
      )}
    </React.Fragment>
  );

  // if (!map) return null;
  // return (
  //   <>
  //     {/* Floorplan image */}
  //     {/* <GroundOverlay
  //       url={imageUrl}
  //       opacity={0.75}
  //       bounds={{
  //         south: derived.sw.lat,
  //         west: derived.sw.lng,
  //         north: derived.ne.lat,
  //         east: derived.ne.lng,
  //       }}
  //     /> */}

  //     {/* NW corner handle */}
  //     {/* <AdvancedMarker
  //       draggable
  //       position={nw}
  //       onDragEnd={(e) => updateCorner("nw", e.latLng)}
  //     /> */}

  //     {/* SE corner handle */}
  //     {/* <AdvancedMarker
  //       draggable
  //       position={se}
  //       onDragEnd={(e) => updateCorner("se", e.latLng)}
  //     /> */}

  //     {/* Drag center to move whole overlay */}
  //     {/* <AdvancedMarker
  //       draggable
  //       position={center}
  //       onDragEnd={(e) => moveWhole(e.latLng)}
  //     /> */}
  //   </>
  // );
};

const FloorplanOverlayOld = ({
  img,
  curFloor,
  opacity,
  rotate,
  selectedGeometry,
  setSelectedGeometry,
  setPosition,
  setPosition1,
}) => {
  // const [drawing, setDrawing] = useState(false);
  const overlayRef = useRef();
  const map = useMap();
  const mapLibCore = useMapsLibrary("core");
  const mapLibMaps = useMapsLibrary("maps");
  // const mapLibMarker = useMapsLibrary("marker");
  // const mapLibGeometry = useMapsLibrary("geometry");

  useEffect(() => {
    // if (mapApi && map && img) {
    //   setTimeout(() => addImage(), 1500);
    // }
    if (map && !img) {
      overlayRef.current && overlayRef.current.setMap(null);
      overlayRef.current = null;
    }
    // if (curFloor?.rotation) {
    //   setRotate(curFloor.rotation);
    // }
    // if (curFloor?.altitude) {
    //   setAltitude(curFloor.altitude);
    // }
    // if (mapApi && map && !drawingManager) {
    //   initDrawPolygon();
    // }
    // if (mapApi && map && curFloor?.polygon) {
    //   initPolygon();
    // }
  }, [map, img, curFloor]);

  const addImage = useCallback(() => {
    if (
      !img ||
      !curFloor ||
      !map ||
      !mapLibCore ||
      !mapLibMaps ||
      !setPosition ||
      !setPosition1
    )
      return;

    // console.log("addImage inner");

    let northWest = map.getCenter();
    if (overlayRef.current) {
      overlayRef.current.setMap(null);
      overlayRef.current = null;
    }

    overlayRef.current = new mapLibMaps.OverlayView();
    overlayRef.current.div = null;
    overlayRef.current.image = img;
    overlayRef.current.position = curFloor
      ? new mapLibCore.LatLng(
          curFloor.northWestLatitude,
          curFloor.northWestLongitude
        )
      : northWest;
    overlayRef.current.position1 =
      curFloor?.southEastLatitude && curFloor.southEastLongitude
        ? new mapLibCore.LatLng(
            curFloor.southEastLatitude,
            curFloor.southEastLongitude
          )
        : null;

    overlayRef.current.draw = function (drawing) {
      if (map.getHeading() !== 360 - rotate && map.getHeading() !== rotate) {
        map.setHeading(360 - rotate);
        this.rotating = true;
      }
      const overlayProjection = this.getProjection();
      if (this.div && overlayProjection) {
        let pos1 = overlayProjection.fromLatLngToDivPixel(this.position);
        this.div.style.left = pos1.x + "px";
        this.div.style.top = pos1.y + "px";
        if (
          this.position1 &&
          this.div.style.cursor !== "move" &&
          this.rotating === false &&
          drawing
        ) {
          const se = overlayProjection.fromLatLngToDivPixel(this.position1);
          this.div.style.width = se.x - pos1.x + "px";
          this.div.style.height = "fit-content";
        }
        this.rotating = false;
      }
      setPosition(this.position);
      setPosition1(this.position1);
    };

    overlayRef.current.onRemove = function () {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
      }
    };

    overlayRef.current.onAdd = function () {
      let that = this;

      this.div = document.createElement("div");
      this.div.id = "whole-container";
      this.div.style.borderStyle = "none";
      this.div.style.borderWidth = "0px";
      this.div.style.visibility = "visible";
      this.div.style.position = "absolute";
      this.div.style.height = "fit-content";
      this.div.style.cursor = "default";

      const img = document.createElement("img");

      const leftTop = document.createElement("span");
      const rightTop = document.createElement("span");
      const leftBot = document.createElement("span");
      const rightBot = document.createElement("span");
      leftTop.classList = "leftTop move-sqare";
      rightTop.classList = "rightTop move-sqare";
      leftBot.classList = "leftBot move-sqare";
      rightBot.classList = "rightBot move-sqare";

      this.div.appendChild(leftBot);
      this.div.appendChild(leftTop);
      this.div.appendChild(rightTop);
      this.div.appendChild(rightBot);

      const handleScaleMousedown = function (e) {
        // console.log("mousedown", e);
        e.stopPropagation();
        that.isScaling = true;
        map.set("draggable", true);
        that.div.draggable = true;
        that.set("origin", e);
        e.target.addEventListener("drag", handleScaleMousemove);
      };

      const handleScaleMousemove = function (e) {
        // console.log("mousemove", { e, that });
        // e.stopPropagation();
        if (!that.isScaling) return;
        let dragType = e.target.className;
        let origin = that.get("origin");
        if (dragType.indexOf("rightBot") > -1) {
          let left = e.clientX - origin.clientX;
          that.div.style.width = that.div.clientWidth + left + "px";
        } else if (dragType.indexOf("leftTop") > -1) {
          let left = origin.clientX - e.clientX;
          let widthPerHeight = that.div.clientWidth / that.div.clientHeight;
          that.div.style.top =
            parseInt(that.div.style.top) - left / widthPerHeight + "px";
          that.div.style.height =
            that.div.clientHeight + left / widthPerHeight + "px";
          that.div.style.width = that.div.clientWidth + left + "px";
          that.div.style.left = parseInt(that.div.style.left) - left + "px";
        } else if (dragType.indexOf("leftBot") > -1) {
          let left = origin.clientX - e.clientX;
          let widthPerHeight = that.div.clientWidth / that.div.clientHeight;
          that.div.style.height =
            that.div.clientHeight + left / widthPerHeight + "px";
          that.div.style.width = that.div.clientWidth + left + "px";
          that.div.style.left = parseInt(that.div.style.left) - left + "px";
        } else if (dragType.indexOf("rightTop") > -1) {
          let left = e.clientX - origin.clientX;
          let widthPerHeight = that.div.clientWidth / that.div.clientHeight;
          that.div.style.height =
            that.div.clientHeight + left / widthPerHeight + "px";
          that.div.style.width = that.div.clientWidth + left + "px";
          that.div.style.top =
            parseInt(that.div.style.top) - left / widthPerHeight + "px";
        }
        that.set("origin", e);
        that.position = that.getProjection().fromDivPixelToLatLng({
          x: parseInt(that.div.style.left),
          y: parseInt(that.div.style.top),
        });
        let pos = that.getProjection().fromLatLngToDivPixel(that.position);
        let x = pos.x + that.div.clientWidth;
        let y = pos.y + that.div.clientHeight;
        let bottom = that.getProjection().fromDivPixelToLatLng({ x, y });
        that.position1 = bottom;
        that.draw(true);
        setPosition && setPosition(that.position);
        setPosition1 && setPosition1(that.position1);
      };

      const handleScaleMouseup = function (e) {
        // console.log("mouseup", e);
        e.stopPropagation();
        that.isScaling = false;
        map.set("draggable", true);
        that.div.draggable = true;
        e.target.removeEventListener("drag", handleScaleMousemove);
      };

      let arr = [leftTop, rightTop, leftBot, rightBot];
      this.div.draggable = true;

      img.src = this.image;
      img.style.width = "100%";
      img.style.height = "100%";
      this.div.appendChild(img);

      arr.forEach((item) => {
        item.draggable = true;
        item.addEventListener("mousedown", handleScaleMousedown);
        item.addEventListener("mouseup", handleScaleMouseup);
      });

      const handleDragMouseleave = function (e) {
        const evt = new Event("mouseup", { bubbles: true });
        that.div.dispatchEvent(evt);
        mapLibCore.event.trigger(this.div, "mouseup");
        arr.forEach((item) => {
          item.dispatchEvent(evt);
        });
      };

      const handleDragMousedown = function (e) {
        that.moving = true;
        that.div.style.cursor = "move";
        map.set("draggable", false);
        that.set("origin", e);

        that.moveHandler = that.div.addEventListener(
          "mousemove",
          handleDragMousemove
        );
      };

      const handleDragMousemove = function (e) {
        if (!that.moving) return;

        let origin = that.get("origin");
        let left = origin.clientX - e.clientX;
        let top = origin.clientY - e.clientY;
        let pos = that.getProjection().fromLatLngToDivPixel(that.position);
        let latLng = that
          .getProjection()
          .fromDivPixelToLatLng(
            new mapLibCore.Point(pos.x - left, pos.y - top)
          );
        that.set("origin", e);
        that.set("position", latLng);
        let pos1 = {
          x: pos.x + that.div.clientWidth,
          y: pos.y + that.div.clientHeight,
        };
        let sw = that.getProjection().fromDivPixelToLatLng(pos1);
        that.position1 = sw;
        that.draw();
      };

      const handleDragMouseup = function (e) {
        // console.log("mouse up drag down");
        that.isScaling = false;
        map.set("draggable", true);
        that.div.draggable = true;
        that.div.style.cursor = "default";
        that.moving = false;
        // mapLibCore.event.removeListener(that.moveHandler);
        // mapLibCore.event.removeListener(that.scaleHandler);
      };

      map.addListener("mouseleave", handleDragMouseleave);
      that.div.addEventListener("mousedown", handleDragMousedown);

      map.addListener("mouseup", handleDragMouseup);
      // this.div.addEventListener("mousedown", );

      // mapLibCore.event.addListener(this.div, "mouseup", function () {
      //   that.div.draggable = true;
      //   map.set("draggable", true);
      //   that.moving = false;
      //   that.div.style.cursor = "default";
      //   that.isScaling = false;
      //   mapLibCore.event.removeListener(that.moveHandler);
      //   mapLibCore.event.removeListener(that.scaleHandler);
      // });

      // map.addListener("zoom_changed", () => {
      //   that.div.style.visibility = "hidden";
      //   setTimeout(() => {
      //     that.draw(true);
      //     that.div.style.visibility = "visible";
      //   }, 500);
      // });

      this.set("this.div", this.div);
      this.getPanes().overlayMouseTarget.appendChild(this.div);
      this.getPanes().overlayMouseTarget.style["zIndex"] = 0;

      map.addListener("zoom_changed", () => {
        that.div.style.visibility = "hidden";
        setTimeout(() => {
          that.draw(true);
          that.div.style.visibility = "visible";
        }, 50);
      });

      if (!that.position1) {
        that.div.style.width = "100px";
        setTimeout(() => {
          if (!that.map) return;
          let pos = that.getProjection().fromLatLngToDivPixel(that.position);
          let pos1 = {
            x: pos.x + that.div.clientWidth,
            y: pos.y + that.div.clientHeight,
          };
          let sw = that.getProjection().fromDivPixelToLatLng(pos1);
          that.position1 = sw;
          map.setCenter(middle(that.position, that.position1));
          that.draw();
        }, 500);
      } else {
        if (
          curFloor &&
          curFloor.northWestLongitude &&
          curFloor.southEastLatitude &&
          curFloor.northWestLatitude &&
          curFloor.southEastLongitude
        ) {
          let d = getDistance(
            new mapLibCore.LatLng(
              curFloor.northWestLatitude,
              curFloor.northWestLongitude
            ),
            new mapLibCore.LatLng(
              curFloor.southEastLatitude,
              curFloor.southEastLongitude
            )
          );
          let keys = Object.keys(radiusZoomLevel).reverse();
          let value = 100000000000;
          let index = 0;
          for (let i = 0; i < keys.length; i++) {
            let v = Math.abs(radiusZoomLevel[keys[i]] - d);
            if (v < value) {
              value = v;
              index = keys[i];
            }
          }
          map.setZoom(Number(index));
          setTimeout(() => {
            map.setZoom(Number(index) - 1);
            // setLoading(false);
          }, 500);
        } else if (curFloor) {
          setTimeout(() => {
            map.setZoom(21);
            // setLoading(false);
          }, 500);
        }
        map.setCenter(middle(that.position, that.position1));
      }
    };

    overlayRef.current.setMap(map);
  }, [img, curFloor, map, mapLibCore, mapLibMaps, setPosition, setPosition1]);

  useEffect(() => {
    // console.log("addImage");
    setTimeout(() => addImage(), 100);
  }, [addImage]);

  useEffect(() => {
    if (!curFloor || !curFloor.polygon || !mapLibMaps) return;
    if (selectedGeometry) {
      selectedGeometry.setMap(null);
      setSelectedGeometry(null);
    }

    let firstItem = curFloor.polygon[0].split(",");
    let minLat = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
      maxLat = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
      minLng = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
      maxLng = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) };
    let arr = curFloor.polygon.map((item) => {
      let me = item.split(",");
      let lng = Number(me[0]);
      let lat = Number(me[1]);
      if (lat > maxLat.lat) maxLat = { lat, lng };
      if (lat < minLat.lat) minLat = { lat, lng };
      if (lng > maxLng.lng) maxLng = { lat, lng };
      if (lng < minLng.lng) minLng = { lat, lng };
      return { lng, lat };
    });

    let newSelectedGeometry = new mapLibMaps.Polygon({
      paths: arr,
      strokeColor: "#000000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#242424",
      fillOpacity: 0.3,
      editable: false,
      draggable: false,
      type: "polygon",
      zIndex: 99999,
    });
    newSelectedGeometry.setMap(map);
    setSelectedGeometry(newSelectedGeometry);
  }, [curFloor, mapLibMaps]);

  useEffect(() => {
    if (overlayRef.current)
      overlayRef.current.div.style.opacity = opacity / 100;
  }, [opacity]);

  // useEffect(() => {
  //   if (!overlayRef.current) return;
  //   let overlay = overlayRef.current;
  //   if (drawing) {
  //     overlay.getPanes().overlayMouseTarget.childNodes.length > 0 &&
  //       overlay.getPanes().overlayMouseTarget.removeChild(overlay.div);
  //     overlay.getPanes().overlayLayer.appendChild(overlay.div);
  //     selectedGeometry && selectedGeometry.setDraggable(true);
  //     selectedGeometry && selectedGeometry.setEditable(true);
  //     overlay.div.childNodes.forEach((item) => {
  //       if (item.nodeName === "SPAN") item.style.visibility = "hidden";
  //     });
  //   } else {
  //     selectedGeometry && selectedGeometry.setDraggable(false);
  //     selectedGeometry && selectedGeometry.setEditable(false);
  //     overlay.getPanes().overlayLayer.childNodes.length > 0 &&
  //       overlay.getPanes().overlayLayer.removeChild(overlay.div);
  //     overlay.getPanes().overlayMouseTarget.appendChild(overlay.div);
  //     overlay.div.childNodes.forEach((item) => {
  //       if (item.nodeName === "SPAN") item.style.visibility = "visible";
  //     });
  //   }
  // }, [drawing]);

  useEffect(() => {
    if (!map) return;
    // rotateRef.current = rotate;
    if (overlayRef.current && overlayRef.current.div) {
      let pos = overlayRef.current
        .getProjection()
        .fromLatLngToDivPixel(overlayRef.current.position);
      let pos1 = {
        x: pos.x + overlayRef.current.div.clientWidth,
        y: pos.y + overlayRef.current.div.clientHeight,
      };
      let sw = overlayRef.current.getProjection().fromDivPixelToLatLng(pos1);
      overlayRef.current.position1 = sw;
      overlayRef.current.rotating = true;
    }
    map.setHeading(360 - rotate);
  }, [map, rotate]);

  return null;
};

export default FloorplanOverlay;
